export default "__VITE_ASSET__C73KPz5s__"